import { render, staticRenderFns } from "./shareFile.vue?vue&type=template&id=263d1f96"
import script from "./shareFile.vue?vue&type=script&lang=js"
export * from "./shareFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports